export interface UpdateInspectionRequest {
  id: number
  branchCodes: {
    from: string
    to: string
    not: boolean
  }[]
  collectionTypes: {
    from: string
    to: string
    not: boolean
  }[]
  shelfTypes: {
    from: string
    to: string
    not: boolean
  }[]
  revision: number
}

export function UpdateInspectionRequestToJSON(
  value: UpdateInspectionRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    branch_codes:
      value.branchCodes.length > 0
        ? value.branchCodes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined,
    collection_types:
      value.collectionTypes.length > 0
        ? value.collectionTypes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined,
    shelf_types:
      value.shelfTypes.length > 0
        ? value.shelfTypes.map(value => {
            return {
              from: value.from !== '' ? value.from : undefined,
              to: value.to !== '' ? value.to : undefined,
              not: value.not ?? undefined
            }
          })
        : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
